import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { apolloService } from '../../common/services'

import { LOCATION_NAMES_QUERY } from '../../locations/graphql/queries'
import { FETCH_LOCATION_NAMES } from '../redux/action-types'

const useLocationNamesLazyQuery = () => {
  const dispatch = useDispatch()

  const {
    isLocationNamesLoading: isLoading,
    locationNamesError: error,
    locationNames: data,
  } = useSelector(store => store.menuCurationTasks.menuCurationTask)

  const fetch = useCallback(
    menuId =>
      apolloService.query({
        query: LOCATION_NAMES_QUERY,
        variables: {
          menuId,
        },
        dispatch,
        action: FETCH_LOCATION_NAMES,
      }),
    [dispatch],
  )

  return [fetch, { isLoading, error, data }]
}

export default useLocationNamesLazyQuery
